module.exports = __webpack_public_path__ + "img/tema-3-4.1be4816b.png";